import { render, staticRenderFns } from "./RestoreSuccessModal.vue?vue&type=template&id=c0171b88"
import script from "./RestoreSuccessModal.vue?vue&type=script&lang=js"
export * from "./RestoreSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports